module.exports = __webpack_public_path__ + "img/home.f5329f2.png";